/**
 * Horário de operação avaliado no aparelho — só quando o heartbeat falha. Online, quem decide é a API
 * (heartbeat.operatingHoursAction); offline, o player usa o último horário recebido para não ficar preto o dia todo
 * (ou aceso a noite toda) porque a rede caiu. Espelho de isWithinOperatingHours da API: fim exclusivo, start > end
 * atravessa a meia-noite e essa parte pertence ao dia em que a janela começou, end 0 = até 24:00.
 */
import type { HeartbeatResponse, OperatingHours } from '@/types/player.types'

export function isWithinOperatingHours(
  hours: OperatingHours | null | undefined,
  parts: { weekday: number; minutesFromMidnight: number }
): boolean {
  if (!hours || hours.alwaysOn) return true
  const { weekday, minutesFromMidnight: minute } = parts
  const { activeDays, startMinutes, endMinutes } = hours
  if (startMinutes <= endMinutes) {
    return !!activeDays[weekday] && minute >= startMinutes && minute < endMinutes
  }
  if (minute >= startMinutes) return !!activeDays[weekday]
  if (minute < endMinutes) return !!activeDays[(weekday + 6) % 7]
  return false
}

export function localOperatingHoursAction(
  hours: OperatingHours | null | undefined,
  parts: { weekday: number; minutesFromMidnight: number }
): NonNullable<HeartbeatResponse['operatingHoursAction']> {
  return isWithinOperatingHours(hours, parts) ? 'none' : 'black_screen'
}
